import { css } from '@emotion/react';

const emotionReset = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

export const customReset = css`
  ${emotionReset}

  html,
    body {
    height: 100%;
  }

  img {
    display: block;
    max-width: 100%;
    border-width: 0;
    -ms-interpolation-mode: bicubic;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  input,
  select,
  textarea,
  button,
  details,
  summary {
    outline: none;
    padding: 0;

    &:focus {
      outline: none;
    }
  }

  input {
    &:focus {
      outline-style: 0;
      box-shadow: none;
      border-color: transparent;
    }

    &::-ms-clear {
      display: none;
    }
  }

  button {
    border: none;
    margin: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    line-height: inherit;
    -webkit-appearance: none;
  }

  summary {
    &::marker {
      display: none;
    }
  }
`;

export default { customReset };
